var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"2","color":"background"}},[_c('v-card-text',{staticClass:"flex-1"},[_c('stats-card')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }